var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "navbar" },
    [
      _vm.showLogo
        ? _c("logo", { attrs: { collapse: _vm.isCollapse } })
        : _vm._e(),
      _c("hamburger", {
        staticClass: "hamburger-container",
        class: { "hamburger-close-slide": _vm.isCollapse },
        attrs: { "is-active": _vm.sidebar.opened },
        on: { toggleClick: _vm.toggleSideBar },
      }),
      _c(
        "div",
        {
          staticClass: "right-menu",
          staticStyle: { display: "flex", "align-items": "center" },
        },
        [
          _c("time-zone-select", {
            staticClass: "right-menu-item hover-effect lang-select",
            staticStyle: {
              height: "60px",
              "line-height": "60px",
              "margin-right": "32px",
            },
          }),
          _c("DownLoadManage", { staticStyle: { "margin-right": "32px" } }),
          _c(
            "div",
            { staticStyle: { height: "60px", "line-height": "60px" } },
            [
              _c("country-select", {
                staticClass: "right-menu-item hover-effect lang-select",
                staticStyle: { "margin-right": "32px" },
              }),
              !_vm.$store.getters.isAruxpay
                ? _c("lang-select", {
                    staticClass: "right-menu-item hover-effect lang-select",
                    staticStyle: { "margin-right": "32px" },
                  })
                : _vm._e(),
              _vm.$store.getters.isEz || _vm.$store.getters.isAruxpay
                ? _c("message-manage", {
                    staticClass: "right-menu-item hover-effect lang-select",
                    staticStyle: { "margin-right": "32px" },
                  })
                : _vm._e(),
              _c("div", { staticClass: "username" }, [
                _c("span", [_c("strong", [_vm._v(_vm._s(_vm.name))])]),
              ]),
              _c(
                "el-dropdown",
                {
                  staticClass: "avatar-container right-menu-item hover-effect",
                  attrs: { trigger: "click" },
                },
                [
                  _c("div", { staticClass: "avatar-wrapper" }, [
                    _c("img", {
                      staticClass: "user-avatar",
                      attrs: {
                        src: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACgAAAAoCAYAAACM/rhtAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAASmSURBVHgBzVltTFtVGH7PubctUIowTBnlwyGx3RAYDnVZUNQsGv2B20xqssTEGM1i3A/N4scvg8v+mEz3w0QT3Q9/akLm2HTJJDIYsWhIGtmcFUjq+NAiIKj9oPTe3nt23m5tGOvH7YG0e/703nvOaZ++73ve87zvJSAIV9fzNguTSk0lzEZ0UkqAyZSAhGM6A02SSUzVmQIqXQ3r8fCk53wIBEDymex2u6U/gpqdxvSaJBmjoBpTGCWh4KIp4PP1KUbXGSKIxGbDWi2s6TWwBSAMlo0SzUmw/ZlDdovCHPlaLBfQopqJBMYG+5ezzcv6o3ufe6HexMkRAhS2GNzdErdkpcPpkgP+yWCmeWktiC6dWVGbiQ42KAA41dWGKnmqr69P2ziW1jKzK4qrUOQQTGNlaJB0Y3e4GN0KKlRCgcHdbUnn7tsIPrr/YDVRWT0UCTyfWqudu7QF/0Qk+Szl4ha326ypzAFFBmYM3APJ+xTBiiXVIUvEDEUGprPp/5WUoRK7GK1n+0dtA0G8/87Rzu7H9h0ps5Y6JUptoVDEO/Lj2BcnTn7iBUE03msax12dMGWz3dnAqZaBAD47dbznicf3fWSxmHkyJxZ8htfOB5p69rS1zl8YGJoCASwHQZ+f/T2ccDE/1IVSyqGeZx2721uPZRrv6Gg59tDuB4W+m0o3j1WKqkQ09p7e37UHXZrxR/jYqy+/+CQIAGOxi3Oj5VQuB0FUVVTk3PXVlZW1IIgQl3MUNF0o9hD/BoOBXHOWV4LzIAjUmtQki6eW019+fVnX9YxCVNP00OBlj/BONsdZGdUos4AgfrnyW2j86sTHmcav/Oo7dfbbizmtnAlxrnikhqaddbAJXPj+0lStvcZbu93uwPSCVotEVq/9cMlz/L3eD4dhE0CZR/Y+dbAT7mLIWOCIqmU8QZqadzjt26qcVqvVRW+lHEVRA5oWDwUWl7zX/dNTJ05+KhSHyI10dh9oyycPYuJ9980jhxsb6w9ny4HrocTjgavXfKcHh37y5hOTKGRliJNVbj9DBPHkeOvoK59bzOa8cptZlh0Pd7T3tre2ILnXjZLEspWqQAzXq2+89lJvvuQ2EsXvMLyA19TURrSo0fk2m3XTG8rKFY/RuSW84KceXvFjMEKBQA3GrcRIDLkl1Iyu0QUji6LRNSHptB6KEjcUfzqwMH4mCN6/XVo0suhM/8UPYjFF+GzFP/jVme/eNjIXOw/4maqLu7sPNMQkYoe7ANga+Xm4fxqvUzVJTY05UMhYzASMvaT1EvfJC5/Px3Y4dulMhnugiNAl+HN87Jtw8v62I25ubiLS3OiS+dlnhSLAorHF0eFzf69/dscZPDMzGaxr3mnDSh8KCDzWPEP9/o3P0/Zm7ttm8uMCKBCYCiFsHqUby9ofLMTORreOjJybyzSeVWbdcrei8x40l2QybCEYEC5T9MDo6PmsiTunDvzr+kS08pG2/0oiuixa3G8EWq3ObvIPDJzNKVTyaqJjiwR7OHEg5bw9mtcmQouZFG3J4bAspGtUbgnB9cCieg1ral62YmXI85cZX0UkyWDS5339KMo5VEwewdcQNwBzMNafo6WRXAAAAABJRU5ErkJggg==",
                      },
                    }),
                    _c("i", {
                      staticClass: "el-icon-caret-bottom icon-arrow-down",
                    }),
                  ]),
                  _c(
                    "el-dropdown-menu",
                    {
                      staticClass: "user-dropdown",
                      attrs: { slot: "dropdown" },
                      slot: "dropdown",
                    },
                    [
                      _c(
                        "el-dropdown-item",
                        {
                          nativeOn: {
                            click: function ($event) {
                              return _vm.gotoAccountSetting($event)
                            },
                          },
                        },
                        [
                          _c("span", { staticClass: "nav-settings-item" }, [
                            _vm._v(_vm._s(_vm.$t("menu.account_settings"))),
                          ]),
                        ]
                      ),
                      _c(
                        "el-dropdown-item",
                        {
                          nativeOn: {
                            click: function ($event) {
                              return _vm.logout($event)
                            },
                          },
                        },
                        [
                          _c(
                            "span",
                            {
                              staticClass: "nav-settings-item",
                              staticStyle: { color: "#FF332E" },
                            },
                            [
                              _vm._v(
                                " " + _vm._s(_vm.$t("components.login_out"))
                              ),
                            ]
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }